import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Inbox = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Inbox" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.7002 1C17.8856 1 18.9598 1.69808 19.4414 2.78125L22.5693 9.81836C22.8534 10.4575 23 11.1492 23 11.8486V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V11.8486C1.00003 11.1492 1.14664 10.4575 1.43066 9.81836L4.55859 2.78125C5.04018 1.69809 6.11438 1 7.2998 1H16.7002ZM3 19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V15H17V16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16V15H3V19ZM7.2998 3C6.90463 3 6.54625 3.23263 6.38574 3.59375L3.25879 10.6309C3.08842 11.0143 3.00003 11.4291 3 11.8486V13H7C8.10457 13 9 13.8954 9 15V16H15V15C15 13.8954 15.8954 13 17 13H21V11.8486C21 11.4291 20.9116 11.0143 20.7412 10.6309L17.6143 3.59375C17.4538 3.23264 17.0954 3 16.7002 3H7.2998Z" fill="#000" />
  </StyledIcon>
));

Inbox.displayName = 'Inbox';

export { Inbox };
